  <template>
    <div
      style="background-image: url('/img/Header.png');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        min-height: 100vh;"
    >
    <div
    class="d-flex flex-column justify-content-center align-items-center"
    style="min-height: 100vh;"
    >
    <b-row class="text-white text-center mt-5 mt-sm-0 mb-4">
      <b-col>
        <h1 class="text-white display-4 text-bold">Hubungi Kami</h1>
        <p>Satu Klik untuk Terhubung dengan kami.</p>
      </b-col>
    </b-row>
        <b-container>
          <b-row class="justify-content-center g-1">
            <b-col
              v-for="(item, index) in contactItems"
              :key="index"
              cols="12"
              xl="3"
              class="px-1 mb-3 d-flex justify-content-center"
            >
              <a
                :href="item.link"
                target="_blank"
                rel="noopener noreferrer"
                class="d-flex flex-column justify-content-start align-items-center p-3 border rounded-lg text-black text-center"
                style="min-height: 215px; max-height: 215px; max-width: 350px; min-width: 350px; font-size: 14px; text-decoration: none; background-color: white; transition: 0.3s;"
              >
                <img
                  :src="require(`@/assets/images/${item.icon}`)"
                  style="margin-top:-15px;"
                  alt="icon"
                  width="250"
                  height="250"
                />
              </a>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </template>
  <script>
  import Ripple from 'vue-ripple-directive'
  import {
    BContainer,
    BRow,
    BCol,
    BButton,
    BCard,
    BCardText,
    BCollapse,
    VBToggle
  } from 'bootstrap-vue'

  export default {
    components: {
      BContainer,
      BRow,
      BCol,
      BButton,
      BCard,
      BCardText,
      BCollapse
    },
    directives: {
      Ripple,
      'b-toggle': VBToggle
    },
    data() {
      return {
        contactItems: [
          {
            icon: 'Email1.png',
            link: 'https://mail.google.com/mail/?view=cm&fs=1&to=productcatalog@telkom.co.id'
          },
          {
            icon: 'location2.png',
            link: 'https://g.co/kgs/2DJhy3W'
          },
          {
            icon: 'whatsapp2.png',
            link: ' https://api.whatsapp.com/send/?phone=6282110576294&text=Hai+Besty%21+Saya+ingin+mengetahui+informasi+terkait+produk+Digital+Connectivity&type=phone_number&app_absent=0'
          }
        ],
        faqs: [
          {
            question: "Bagaimana cara mengajukan permintaan akun baru (Account Request)?",
            answer:
              "Untuk mengajukan permintaan akun baru, isi formulir lengkap pada kategori 'Account Request'. Setelah dikirim, tim kami akan memproses dalam 1–3 hari kerja dan menghubungi Anda untuk verifikasi."
          },
          {
            question: "Apa yang harus saya lakukan jika saya memiliki pertanyaan umum (Questions)?",
            answer:
              "Silakan pilih kategori 'Questions' dan jelaskan secara rinci pertanyaan Anda. Tim kami akan memberikan jawaban lengkap secepatnya, biasanya dalam 1 hari kerja."
          },
          {
            question: "Bagaimana cara mengajukan permintaan pendampingan?",
            answer:
              "Pilih kategori 'Permintaan Pendampingan' dan jelaskan kebutuhan Anda. Tim kami akan menghubungi Anda untuk menjadwalkan sesi pendampingan sesuai permintaan."
          },
          {
            question: "Berapa lama waktu tanggapan untuk setiap kategori pesan?",
            answer:
              "Account Request: 1–3 hari kerja. Questions: < 24 jam. Permintaan Pendampingan: hingga 5 hari kerja. Mohon beri keterangan jika pesan bersifat urgent."
          },
          {
            question: "Bagaimana jika saya tidak mendapatkan respon setelah mengirim pesan?",
            answer:
              "Silakan periksa folder spam email Anda. Jika belum ada respon, hubungi kembali via telepon/WA dan pastikan email/nomor Anda benar."
          }
        ]
      }
    },
  }
  </script>

  <style scoped>
  label {
    color: white !important;
  }
  a:hover {
    background-color: rgba(255, 255, 255, 0.1);
    text-decoration: none;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }
  .text-wrapper {
    margin-top: 16px;
  }

  .text-wrapper strong {
    font-size: 15px;
  }
  a:hover {
    background-color: rgba(255, 255, 255, 0.1);
    text-decoration: none;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }
  </style>
